var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"canvas",style:({
          left: _vm.left + 'px',
          top: _vm.top + 'px',
          width: _vm.width + 'px',
          height: _vm.height + 'px'
        }),on:{"click":_vm.onCanvasClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }